import PropTypes from "prop-types";
import React from "react";

import Col from "~/components/layout/Col";
import ContentContainer from "~/components/layout/ContentContainer";
import Row from "~/components/layout/Row";
import SectionWrapper from "~/components/layout/SectionWrapper";

import EventCardSmall from "~/components/EventCardSmall";
import NewsCard from "~/components/NewsCard";
import SectionHeading from "~/components/SectionHeading";

const News = ({
    backgroundColor = "white",
    cards = [],
    title = "",
    linkLabel = "",
    linkUrl = "",
    withBorder = false,
    sectionId = "",
}) => (
    <SectionWrapper
        {...{ sectionId, withBorder, backgroundColor }}
        withPadding={backgroundColor === "gray"}
    >
        <ContentContainer>
            <SectionHeading
                {...{ title }}
                links={linkLabel && linkUrl ? [{ linkLabel, linkUrl }] : []}
            />
            <Row noGutter noVerticalSpacing>
                {cards.map(({ typename, id, ...card }) => (
                    <Col flex noGutter key={id} sm={1 / 2} md={1 / 4}>
                        {typename === "WpNewsArticle" ? (
                            <NewsCard {...card} />
                        ) : (
                            <EventCardSmall {...card} withIcon />
                        )}
                    </Col>
                ))}
            </Row>
        </ContentContainer>
    </SectionWrapper>
);

News.propTypes = {
    backgroundColor: PropTypes.oneOf(["white", "gray"]),
    cards: PropTypes.arrayOf(PropTypes.shape({})),
    title: PropTypes.string,
    linkLabel: PropTypes.string,
    linkUrl: PropTypes.string,
    withBorder: PropTypes.bool,
    sectionId: PropTypes.string,
};

export default News;
